import Tween from "tween.ts";
import Animation from "./Animation";


export interface FlipAnimationOpts {
  startVal: number,
  targetVal: number, 
  duration: number
}


export default class FlipAnimation extends Animation {
  constructor(options: FlipAnimationOpts, onUpdate: (v: number) => void, onComp: () => void) {
    const { startVal, targetVal, duration } = options;
    super();
    const obj = {v: startVal };
    new Tween.Tween(obj)
      .to({v : targetVal}, duration)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((obj) => onUpdate(obj.v))
      .onComplete(() => onComp())
      .start();
  }
}